import type { Listing } from '@thevillages/schemas';

import { HttpClient } from '@angular/common/http';
import { inject } from '@angular/core';
import { type ResolveFn, Router } from '@angular/router';

import { StateService } from '../../services/state/state';
import { GetById } from './get-by-id';
import { GetByULIKey } from './get-by-uli-key';
import { GetByVLS } from './get-by-vls';

export const ListingResolver: ResolveFn<Listing> = (route) => {
  const _httpClient = inject(HttpClient);
  const _router = inject(Router);
  const _stateService = inject(StateService);

  const _id = route.paramMap.get('id');
  const _token = _stateService.userToken();

  if ((_id?.length ?? 0) < 10) {
    if (_id?.includes('.')) {
      return GetByULIKey(_httpClient, _router, _id || '', _token);
    } else {
      return GetByVLS(_httpClient, _router, _id ?? '', _token);
    }
  } else {
    return GetById(_httpClient, _router, _id ?? '', _token);
  }
};
